import { ShippingOption } from '../types';

const BASE_SHIPPING_COMPONENT_NAME = 'BASE_SHIPPING';

/**
 * Return the base shipping cent amounts for the given shipping option.
 */
export const getBaseShippingPrice = (
  shippingOption: ShippingOption
): {
  grossListCents: number;
  netListCents: number;
  grossDiscountedCents: number;
  netDiscountedCents: number;
} => {
  const baseShippingComponents =
    shippingOption.pricingData?.components.filter(
      comp => comp.name === BASE_SHIPPING_COMPONENT_NAME
    ) || [];

  let grossListCents = 0;
  let netListCents = 0;
  let grossDiscountedCents = 0;
  let netDiscountedCents = 0;
  baseShippingComponents.forEach(comp => {
    grossListCents += comp.grossListCents;
    netListCents += comp.netListCents;
    grossDiscountedCents += comp.grossDiscountedCents;
    netDiscountedCents += comp.netDiscountedCents;
  });

  return {
    grossListCents,
    netListCents,
    grossDiscountedCents,
    netDiscountedCents,
  };
};
